<div class="FormErrorMessage-content {{className}}">
  <div class="FormErrorMessage {{className}}" *ngIf="(fieldInput?.touched && fieldInput?.hasError('required'))">
    {{ errorRequired | translate }}
  </div>
  <div class="FormErrorMessage {{className}}" *ngIf="(fieldInput?.touched && fieldInput?.hasError('pattern')) || fieldInput?.value && fieldInput?.hasError('pattern')">
    {{ errorPattern | translate }}
  </div>
  <div class="FormErrorMessage {{className}}" *ngIf="(fieldInput?.touched && fieldInput?.hasError('nameForm')) || fieldInput?.value && fieldInput?.hasError('nameForm')">
    {{ fieldInput?.getError('nameForm') | translate }}
  </div>
</div>

